import React, { Component } from "react";
import Hero from './../../alpineComponents/hero';
import CenteredParagraph from './../../alpineComponents/centeredParagraph';
import TextAndImage from './../../alpineComponents/textAndImage';
import { Link } from "react-router-dom";
import  './../../utils/analytics';
import ContactForm from './../../components/contactForm';

export default class extends Component {
  render() {
    return (
      <div className="light-grey-background">
        <Hero
          title={'Posture Work'}
          subtitle={'PILATES AVENUE'}
          backgroundImage={'images/posture-hero.jpg'}
          height={'threequarter'}
          subtitlePosition={'bottom'}
          tint={'dark'}
        />
        <div className="section-padding" style={{'paddingTop':"2%"}}>
          <div className="max-width-container">
            <div className="white-background">
              <TextAndImage
                ratio={'square'}
                direction={'left'}
                image={'images/posture-1.jpg'}
                content={
                  <div>
                    <h4>{'Understanding Posture'}</h4>
                    <p className="subheading" style={{marginTop:'20px'}}>{"Slouching, forward head, exaggerated curves of the spine ... it happens. Be it from phone and computer use, sitting or standing for prolonged periods, or even sports and dance. Repeated activities -- or lack of activity -- can leave you with less than ideal posture. The muscle imbalances created can pull the body out of alignment -- overloading joints and causing pain. What's left is a less than ideal way of supporting our bodies."}</p>
                  </div>
                }
              />
              <TextAndImage
                ratio={'square'}
                direction={'right'}
                image={'images/posture-2.jpg'}
                content={
                  <div>
                    <h4>{'Your Path to Better Alignment'}</h4>
                    <p className="subheading" style={{marginTop:'20px'}}>{"We'll start with a posture assessment. Identify personal areas of focus. Then teach you exercises that can help. We'll guide your practice and nurture your body into a more optimal and efficient posture. You'll feel and look taller. Maybe have less pain and better balance. It can even give you a performance edge in your sport or dance. Better alignment helps you to restore the natural curves of your spine, making it least vulnerable to injury. That means you'll carry yourself in a way that helps you move with more ease. Project more confidence. Because better posture is not a look but a way of life."}</p>
                  </div>
                }
              />
            </div>
            <div className="tiny-padding">
              <div className="primary-background">
                <div className="small-max-width-container section-padding" style={{paddingBottom: "50px"}}>
                  <div className="tiny-padding centered-text">
                    <h4 className="white">{'Start Your Posture Journey Today'}</h4>
                    <p className="white">{'Get started on the path to better alignment.'}</p>
                  </div>
                  <ContactForm
                    name={true}
                    email={true}
                    phone={true}
                    buttonText={'Schedule Assessment'}
                    subject={'Posture Assessment Inquiry'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
} 


// WEBPACK FOOTER //
// ./src/pages/posture/index.js